import { Grid } from '@mui/material';
import { useCallback } from 'react';
import { SubjectDataVM } from 'shell/view-models/search-anpr';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import MunicipalityForeignList from 'shell/components/shared/municipality-foreign-list';

interface ForeignStateProps {
  foreignStateBirth?: ForeignStateVM | null;
  foreignMunicipality?: MunicipalityAnprVM | null;
  onChange: (key: keyof SubjectDataVM, value: SubjectDataVM[keyof SubjectDataVM]) => void;
}

const ForeignState = ({
  onChange,
  foreignStateBirth,
  foreignMunicipality,
}: ForeignStateProps): React.ReactElement => {
  // const params: MunicipalityParams = useMemo(() => {
  //   return {
  //     province: foreignStateBirth || '',
  //   };
  // }, [foreignStateBirth]);

  const onChangeForeignStateList = useCallback(
    (foreignState?: ForeignStateVM | null) => {
      onChange('foreignStateBirth', foreignState);
    },
    [onChange]
  );

  const onChangeForeignMunicipalityList = useCallback(
    (municipality) => {
      onChange('foreignMunicipality', municipality);
    },
    [onChange]
  );

  return (
    <Grid item container spacing={2} alignItems="center">
      <Grid item xs={12} md={5}>
        <ForeignStateList
          value={foreignStateBirth || null}
          onChange={onChangeForeignStateList}
          label="Stato estero di nascita"
          id="foreignStateBirth"
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <MunicipalityForeignList
          value={foreignMunicipality || null}
          onChange={onChangeForeignMunicipalityList}
          label="Comune estero"
          id="foreignMunicipality"
          disabled={!foreignStateBirth}
          foreignStateIstatCode={foreignStateBirth?.id}
        />
      </Grid>
    </Grid>
  );
};

ForeignState.displayName = 'Filters Person section Foreign State component';

export default ForeignState;
